import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import Header from '../../components/ui/Header';
import Button from '../../components/ui/Button';
import Icon from '../../components/AppIcon';
import FilterDrawer from './components/FilterDrawer';
import FeaturedCarousel from './components/FeaturedCarousel';
import PromotionsSection from './components/PromotionsSection';
import ZoneSection from './components/ZoneSection';
import gaTrackingService from '../../services/gaTrackingService';


const MainStorefronts = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [filters, setFilters] = useState({
    zone: '',
    category: '',
    distance: 5,
    sortBy: 'relevance',
    openNow: false,
    hasPromo: false,
    hasCashback: false,
    featured: false
  });
  const [isFilterDrawerOpen, setIsFilterDrawerOpen] = useState(false);

  const handleFilterChange = (newFilters) => {
    setFilters(newFilters);
  };

  const handleMapNavigation = () => {
    // Track map navigation in GA4
    gaTrackingService?.trackMapNavigation();
    
    navigate('/interactive-map');
  };

  return (
    <>
      <Helmet>
        <title>Vetrine di Macerata - Scopri le attività locali</title>
        <meta
          name="description"
          content="Esplora le vetrine digitali delle attività commerciali di Macerata. Trova promozioni, cashback e scopri i negozi nella tua zona."
        />
      </Helmet>

      <div className="min-h-screen bg-background">
        <Header onFilterClick={() => setIsFilterDrawerOpen(true)} />

        <main className="pt-16 pb-20 lg:pb-8">
          <div className="max-w-screen-2xl mx-auto px-4 md:px-6">
            <div className="py-6 md:py-8">
              <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4 mb-6">
                <div>
                  <h1 className="font-heading font-bold text-2xl md:text-3xl lg:text-4xl text-foreground mb-2">
                    Vetrine di Macerata
                  </h1>
                  <p className="font-body text-sm md:text-base text-muted-foreground">
                    Scopri le attività locali, promozioni esclusive e cashback
                  </p>
                </div>

                <Button
                  variant="default"
                  size="default"
                  iconName="Map"
                  iconPosition="left"
                  onClick={handleMapNavigation}
                  className="w-full lg:w-auto"
                >
                  Esplora sulla mappa
                </Button>
              </div>
            </div>

            {/* Content area - clean and minimal */}
            <div className="pb-8 md:pb-12">
              <div className="mb-6 md:mb-8">
                <div className="flex items-center gap-3 mb-4 md:mb-6">
                  <div className="w-10 h-10 md:w-12 md:h-12 bg-primary/10 rounded-lg flex items-center justify-center">
                    <Icon name="Star" size={24} className="text-primary" />
                  </div>
                  <div>
                    <h2 className="font-heading font-bold text-xl md:text-2xl lg:text-3xl text-foreground">
                      Vetrine in evidenza
                    </h2>
                    <p className="font-caption text-sm text-muted-foreground">
                      Le migliori attività selezionate per te
                    </p>
                  </div>
                </div>

                <FeaturedCarousel />
              </div>

              <ZoneSection filters={filters} />

              <PromotionsSection />
            </div>
          </div>
        </main>

        {/* Filter Drawer */}
        <FilterDrawer
          isOpen={isFilterDrawerOpen}
          onClose={() => setIsFilterDrawerOpen(false)}
          onFilterChange={handleFilterChange}
        />
      </div>
    </>
  );
};

export default MainStorefronts;